import { apiWebsiteSlice } from "@/redux/app/api/apiSlice";

export const websiteApiSlice = apiWebsiteSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllBlogsWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/blog`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getAllUniversitiesWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/university`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getAllFacultiesWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/faculty`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getAllGeneralFacultiesWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/general-faculty?search=${params.search}`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
    getAllSpecialtiesWithFilters: builder.query({
      query: (params) => ({
        url: `api/filter/specialization`,
        params: { ...params },
      }),
      providesTags: ["Website"],
    }),
  }),
});

export const {
  useGetAllBlogsWithFiltersQuery,
  useGetAllUniversitiesWithFiltersQuery,
  useGetAllFacultiesWithFiltersQuery,
  useGetAllGeneralFacultiesWithFiltersQuery,
  useGetAllSpecialtiesWithFiltersQuery,
} = websiteApiSlice;
